import { useRouter } from "next/router";
import { HStack, VStack } from "@chakra-ui/react";
import { Label01, Paragraph02 } from "~/components/Texts";
import { FiCheckCircle, FiAlertTriangle } from "react-icons/fi";

export default function OrderDetailsPaymentStatusUpdate({ shop }) {
  const router = useRouter();

  switch (router.query.statusUpdate) {
    case "mercadopago_success":
      return <MercadoPagoSuccess shop={shop} />;
    case "mercadopago_failure":
      return <MercadoPagoFailure shop={shop} />;
    case "mercadopago_pending":
      return <MercadoPagoPending shop={shop} />;
    default:
      return null;
  }
}

const MercadoPagoSuccess = ({ shop }) => {
  return (
    <VStack
      backgroundColor="feel.positive"
      color="white"
      borderRadius={shop.theme.radius}
      w="100%"
      px="4"
      py="2"
    >
      <HStack>
        <Label01>
          <FiCheckCircle />
        </Label01>
        <Label01>
          <b>¡Pagaste!</b>
        </Label01>
      </HStack>
      <Paragraph02 textAlign="center">
        Tu pago por MercadoPago fue confirmado.
      </Paragraph02>
    </VStack>
  );
};

const MercadoPagoFailure = ({ shop }) => {
  return (
    <VStack
      backgroundColor="feel.negative"
      color="white"
      borderRadius={shop.theme.radius}
      w="100%"
      px="4"
      py="2"
    >
      <HStack>
        <Label01>
          <FiAlertTriangle />
        </Label01>
        <Label01>
          <b>El pago fue rechazado</b>
        </Label01>
      </HStack>
      <Paragraph02 textAlign="center">
        MercadoPago rechazó el pago de tu compra.
      </Paragraph02>
      <Paragraph02 textAlign="center">
        Por favor, intentalo nuevamente o elegí otro medio de pago para
        completar tu compra.
      </Paragraph02>
    </VStack>
  );
};

const MercadoPagoPending = ({ shop }) => {
  return (
    <VStack
      backgroundColor="feel.warning"
      color="light.brand.strong"
      borderRadius={shop.theme.radius}
      w="100%"
      px="4"
      py="2"
    >
      <HStack>
        <Label01>
          <FiAlertTriangle />
        </Label01>
        <Label01>
          <b>El pago esta pendiente de confirmación</b>
        </Label01>
      </HStack>
      <Paragraph02 textAlign="center">
        MercadoPago está validando el pago.
      </Paragraph02>
      <Paragraph02 textAlign="center">
        Recibirás una actualización en tu correo electrónico cuando el pago sea
        confirmado.
      </Paragraph02>
    </VStack>
  );
};
